import React from 'react';
import './EquipmentCategoryModal.css';

const categories = [
  { 
    id: 'luminaire', 
    label: 'Luminaire', 
    icon: '💡',
    color: '#fdea73'
  },
  { 
    id: 'eclairage_securite', 
    label: 'Éclairage de sécurité', 
    icon: '🚨',
    color: '#ff5f5f'
  },
  { 
    id: 'prise_courant', 
    label: 'Prise de courant', 
    icon: '🔌',
    color: '#ff9f59'
  },
  { 
    id: 'materiel_informatique', 
    label: 'Matériel informatique', 
    icon: '💻',
    color: '#5ce1e6'
  },
  { 
    id: 'materiel_amovible', 
    label: 'Matériel amovible', 
    icon: '☕',
    color: '#5ce197'
  },
  { 
    id: 'recepteurs_fixes', 
    label: 'Récepteurs fixes', 
    icon: '⚡',
    color: '#e1c15c'
  },
  { 
    id: 'materiel_portatif', 
    label: 'Matériels portatifs', 
    icon: '🔧',
    color: '#5ce1e6'
  },
  { 
    id: 'machine_ce', 
    label: 'Machines (CE)', 
    icon: '⚙️',
    color: '#c384ff'
  },
  { 
    id: 'machine_garage', 
    label: 'Machine de garage', 
    icon: '🚗',
    color: '#ff7eb9'
  },
  { 
    id: 'materiel_industriel', 
    label: 'Matériels industriels', 
    icon: '🏭',
    color: '#ffa789'
  },
  { 
    id: 'ddr_circuits_terminaux', 
    label: 'DDR circuits terminaux', 
    icon: '🛡️',
    color: '#a78bfa'
  },
  { 
    id: 'autre', 
    label: 'Autre', 
    icon: '❓',
    color: '#9ca3af'
  }
];

export default function EquipmentCategoryModal({ isOpen, onClose, local, onSelectCategory }) {
  if (!isOpen) return null;

  const handleCategoryClick = (categoryId) => {
    onSelectCategory(categoryId);
  };

  return (
    <div className="category-modal-overlay" onClick={onClose}>
      <div className="category-modal" onClick={(e) => e.stopPropagation()}>
        <div className="category-modal-header">
          <div>
            <h2 className="category-modal-title">
              Ajout rapide d'équipement
            </h2>
            <p className="category-modal-subtitle">
              {local?.nom}
            </p>
          </div>
          <button onClick={onClose} className="category-close-button">✕</button>
        </div>

        <p className="category-modal-description">
          Sélectionnez une catégorie d'équipement :
        </p>

        <div className="category-grid">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => handleCategoryClick(category.id)}
              className="category-card"
              style={{ '--category-color': category.color }}
            >
              <div className="category-icon">{category.icon}</div>
              <div className="category-label">{category.label}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}